export const toggleModalAction = (value) => {
    return { type: 'TOGGLE_MODAL', value }
}

// add selection
export const addCollectionAction = (collection) => { //list
    return { type: 'ADD_COLLECTION', collection }
}

// remove selection
export const removeCollectionAction = (collection) => {
    return { type: 'REMOVE_COLLECTION', collection }
}

export const addAuthorAction = (author) => {
    return { type: 'ADD_AUTHOR', author }
}

export const removeAuthorAction = (author) => {
    return { type: 'REMOVE_AUTHOR', author }
}

export const addVolAction = (vno) => {
    return { type: 'ADD_VOLUME', vno }
}

export const removeVolAction = (vno) => {
    return { type: 'REMOVE_VOLUME', vno }
}

export const addVolumesAction = (volumes) => {
    return { type: 'ADD_VOLUMES', volumes }
}

export const addAuthorsAction = (authors) => {
    return {type: 'ADD_AUTHORS', authors}
}

export const addCollectionsAction = (collections) => {
    return {type: 'ADD_COLLECTIONS', collections}
}

export const removeCollectionsAction = () => {
    return {type: 'REMOVE_COLLECTIONS'}
}

export const removeAuthorsAction = () => {
    return {type: 'REMOVE_AUTHORS'}
}

export const replaceAllAction = (newFilters) => {
    return {type: 'REPLACE_ALL', data: newFilters}
}

export const addYearsAction = (years) => {
    return {type: 'ADD_YEARS', years}
}

export const changeTabAction = tab => {
    return {type: 'CHANGE_TAB', tab}
}

export const addYearAction = (year) => {
    return {type: 'ADD_YEAR', year}
}

export const removeYearAction = year => {
    return {type: 'REMOVE_YEAR', year}
}

export const removeYearsAction = () => {
    return {type: 'REMOVE_YEARS'}
}

export const changeQtypeAction = value => {
    return {type: 'CHANGE_QTYPE', value}
}
export const changeSortOrderAction = value => {
    return {type: 'CHANGE_SORTORDER', value}
}
export const addMonthAction = month => {
    return { type: 'ADD_MONTH', month }
}

export const removeMonthAction = month => {
    return { type: 'REMOVE_MONTH', month }
}
export const addMonthsAction = month => {
    return { type: 'ADD_MONTHS', month }
}

export const removeMonthsAction = month => {
    return { type: 'REMOVE_MONTHS', month }
}
export const addLanguageAction = language => {
    return { type: 'ADD_LANGUAGE', language }
}

export const removeLanguageAction = language => {
    return { type: 'REMOVE_LANGUAGE', language }
}
export const addChapterAction = chapter => {
    return { type: 'ADD_CHAPTER', chapter }
}

export const removeChapterAction = chapter => {
    return { type: 'REMOVE_CHAPTER', chapter}
}

export const addPeriodicalIndexAction = index => {
    return { type: 'ADD_PERIODICAL_INDEX', index }
}

export const removePeriodicalIndexAction = index => {
    return { type: 'REMOVE_PERIODICAL_INDEX', index }
}

export const addPeriodicalIndexesAction = indexes => {
    return { type: 'ADD_PERIODICAL_INDEXES', indexes }
}

export const removePeriodicalIndexesAction = () => {
    return { type: 'REMOVE_PERIODICAL_INDEXES' }
}

export const addMtmIndexAction = index => {
    return { type: 'ADD_MTM_INDEX', index }
}

export const removeMtmIndexAction = index => {
    return { type: 'REMOVE_MTM_INDEX', index }
}

export const addMtmIndexesAction = indexes => {
    return { type: 'ADD_MTM_INDEXES', indexes }
}

export const removeMtmIndexesAction = () => {
    return { type: 'REMOVE_MTM_INDEXES' }
}

export const addArabicIndexAction = index => {
    return { type: 'ADD_ARABIC_INDEX', index }
}

export const removeArabicIndexAction = index => {
    return { type: 'REMOVE_ARABIC_INDEX', index }
}

export const addArabicIndexesAction = indexes => {
    return { type: 'ADD_ARABIC_INDEXES', indexes }
}

export const removeArabicIndexesAction = () => {
    return { type: 'REMOVE_ARABIC_INDEXES' }
}

export const addFilterValueAction = (field, value) => {
    return { type: 'ADD_FILTER_VALUE', field, value }
}

export const removeFilterValueAction = (field, value) => {
    return { type: 'REMOVE_FILTER_VALUE', field, value }
}

export const replaceFilterValuesAction = (field, values) => {
    return { type: 'REPLACE_FILTER_VALUES', field, values }
}

export const clearFilterValuesAction = field => {
    return { type: 'CLEAR_FILTER_VALUES', field }
}
